import { Urls } from "types/urls.types";

export const urls: Urls = {
    API_HOST_URL: "https://api.africasocialprotection.io"
};
